import { InterestRatePageAction, InterestRateState } from './interfaces';

export const initialInterestRateState: InterestRateState = {
  crud: { open: false, record: null, mode: null },
  deleteModal: { open: false, record: null },
};

export function interestRateReducer(prevState: InterestRateState, action: InterestRatePageAction): InterestRateState {
  switch (action.type) {
    case 'openCrud':
      if (!action.mode) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...initialInterestRateState,
        crud: { open: true, record: action.record ?? null, mode: action.mode },
      };
    case 'closeCrud':
      return {
        ...initialInterestRateState,
      };
    case 'openDeleteModal':
      if (!action.record) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...prevState,
        deleteModal: {
          open: true,
          record: action.record,
        },
      };
    case 'closeDeleteModal':
      return {
        ...prevState,
        deleteModal: {
          open: false,
          record: null,
        },
      };
    default:
      throw new Error('No action provided');
  }
}
